<template>
    <div>
      <vs-card class="cstm_vx_card text-center content_mb_0 mb-0">
        <div slot="header">
          <p><img style="width: 70px;" src="https://scoolio-files.s3.ap-south-1.amazonaws.com/Scoolio/quickbook_logo.png" alt="logo" /></p>
          <img style="width: 100%; max-width: 450px;" src="https://scoolio-files.s3.ap-south-1.amazonaws.com/quickbook_logo1+(1).png" alt="logo" />
        </div>

        <!-- <p class="mt-4 mb-8 text-center">
        <label for="">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</label>
        <vs-switch class="m-auto" v-model="quickBook" @click="quickbookActivation"/>
        </p> -->

        <div class="flex flex-wrap justify-center items-center">
          <button v-if="!connectedQuickbook" class="google_signup_btn outline_primary mx-1 mt-0" @click="redirectToQuickbookUrl">
          <span>Connect</span>
          </button>
          
          <button v-else  class="google_signup_btn outline_danger mx-1 mt-0" @click="quickbooksDisconnect">
            <span>Disconnect</span>
          </button>
          <button v-if="connectedQuickbook" class="google_signup_btn outline_primary mx-1 mt-0" @click="quickbooksSync">
            <span>Sync With Quickbook</span>
          </button>
        </div>

      </vs-card>
    </div>
</template>
<script>
import { UserSettings } from './mixins/userSettings'
import { getSetting} from '@/api/setting.js'
import { quickbooksStatus, quickbookSync } from '@/api/common'
export default {
  mixins: [UserSettings],
  data () {
    return {
      quickBook: false,
      connectedQuickbook: false
    }
  },
  mounted () {
    this.redirectToQuickbook()
    this.fetchStatusForQuickbook()
    this.fetchSetting()
  },
  methods: {
    redirectToQuickbookUrl () {
      setTimeout(() => {
        this.connectedQuickbook = true
      }, 1000) 
      window.open(this.redirectionUrl, '_blank')
    },
    async fetchSetting () {
      const { data } = await getSetting(localStorage.getItem('customer_id'))
      if (data.data[0] !== null) {
        this.quickBook = data.data[0].quickbook_enable
      }
    },
    async fetchStatusForQuickbook () {
      const { data } = await quickbooksStatus(localStorage.getItem('customer_id'))
      if (data.data[0] !== null) {
        this.connectedQuickbook = data.data.status
      }
    },
    async quickbooksSync () {
      try {
        const { data } = await quickbookSync({customer_id: localStorage.getItem('customer_id')})
        this.showSuccessMessage('Success', 'Quickbook sync started', 'success')
      } catch (e) {
        this.showSuccessMessage('Warning', 'Something went wrong', 'warning')
      }
    }
    
  }
}
</script>
